import styled from '@emotion/styled';

export const AssetVaultTabWrapper = styled.div`
  display: flex;
  padding: 0px 16px 20px 16px;
  flex-direction: column;
  align-items: flex-start;
  flex: 1 0 0;
`;

export const AssetVaultTabHeader = styled.div`
  display: flex;
  padding: 32px 8px;
  align-items: center;
  gap: 24px;
  align-self: stretch;
`;

export const VaultSearchAndFiltersWrapper = styled.div`
  display: flex;
  align-items: center;
  gap: 6px;
  flex: 1 0 0;
`;

export const AssetVaultTabContent = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
`; 